import React, { useState, useEffect, useMemo } from 'react';
import { Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BiCalendar, BiLoader, BiChevronDown, BiChevronUp, BiEnvelopeOpen, BiEnvelope, BiDownArrowAlt } from "react-icons/bi";
import { makeRequest } from '../../utils/makeRequest';
import * as urls from '../../utils/urlConst';
import toastNotify from '../../utils/toastNotify';
import Loader from '../../components/Loader';
import { useLocation } from 'react-router-dom';
import { exceptionLog } from '../../utils/common';
import { getNotificationAlerts } from '../../apiService/apiService';

interface circularProps {
    AcFor: string,
    CircularType: string,
    Description: string,
    EmailAlert: string,
    EndDate: string,
    PopUpAlert: string,
    StartDate: string,
    Title: string,
    TranCode: string,
    FileStatus?: string,
    ReadStatus?: string,
}

const Circular = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [isCircularLoader, setIsCircularLoader] = useState<boolean>(false);
    const [circularData, setCircularData] = useState<circularProps[]>([]);
    const [isCollapse, setIsCollapse] = useState<any>({});
    const [downloadAtechmentLoader, setDownloadAtechmentLoader] = useState<boolean[]>(Array(circularData.length).fill(false));
    const { state } = useLocation();
    const [currentActiveId, setCurrentActiveId] = useState<any>(null);

    const removeTag = (data: any) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;
        return tempDiv.textContent || tempDiv.innerText
    }

    const fetchCircular = async () => {
        try {
            setIsLoader(true);
            const payload = {};
            const config = {};
            await makeRequest('POST', urls.getCircular, payload, config).then((result) => {
                if (result.STATUS === '0') {
                    const response = result.RESPONSE;
                    setCircularData(response);
                } else {
                    setCircularData([]);
                    result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
                    // toastNotify(result.MESSAGE, 'error')
                };
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Get circular", "N");
            }
        } finally {
            setIsLoader(false);
        }
    };

    useMemo(() => {
        fetchCircular();
    }, []);

    const downloadFile = (base64Data: string, fileName: string, fileType: string) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const fetchDownloadCircular = async (TranCode: string, id: number) => {
        try {
            const loader = [...downloadAtechmentLoader];
            loader[id] = !loader[id];
            setDownloadAtechmentLoader(loader);
            const payload = {
                TranCode: TranCode
            };
            const config = {};
            await makeRequest('POST', urls.downloadCircular, payload, config).then((result) => {
                if (result.STATUS === '0') {
                    const response = result.RESPONSE;
                    downloadFile(response[0].FileBase64, response[0].FileName, response[0].FileContentType);
                } else {
                    result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
                };
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Download circular", "N");
            }
        } finally {
            const loader = [...downloadAtechmentLoader];
            loader[id] = false;
            setDownloadAtechmentLoader(loader)
        }
    };

    const MaskasReadCircular = async (TranCode: String) => {
        try {
            setIsCircularLoader(true);
            const payload = {
                TranCode: TranCode,
                Type: "C"
            };
            const config = {};
            await makeRequest('POST', urls.readCircularAlert, payload, config).then(async (result) => {
                if (result.STATUS === '0') {
                    await getNotificationAlerts();
                    fetchCircular();
                } else {
                    result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
                };
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Read circular in circular", "N");
            }
        } finally {
            setIsCircularLoader(false);
        }
    };

    const toggleAnnouncementData = (id: number) => {
        if (currentActiveId !== null) {
            setIsCollapse((preState: any) => ({ ...preState, [currentActiveId]: false }));
        };
        setCurrentActiveId(id);
        setIsCollapse((preState: any) => ({ ...preState, [id]: !isCollapse[id] }));
    };

    useEffect(() => {
        if (state !== null && circularData.length !== 0) {
            const selectNotification = circularData.findIndex((data: any) => data.TranCode === state.data[0].TranCode);
            toggleAnnouncementData(selectNotification);
        }
    }, [state !== null, circularData.length !== 0]);

    return (
        <div>
            <div className="mb-3 d-flex align-items-center">
                <h2 className="text-base mb-0 fw-semibold">Circular</h2>
            </div>

            {!isLoader ?
                <>
                    {circularData.length !== 0 ?
                        <>
                            {circularData.map((items: any, id: number) => (
                                <Card key={id} className={id > 0 ? "mt-3" : ""}>
                                    <Card.Header className='d-block d-md-flex align-items-center'>
                                        <div>
                                            <div className='text-base fw-semibold'>{items.Title}</div>
                                            {items.CircularType !== "" && items.CircularType !== undefined &&
                                                <div className='text-xs text-slate-500'>{items.CircularType}</div>
                                            }
                                        </div>

                                        <div className='ms-auto text-xs'>
                                            <div className='text-end'>Publish Date : <BiCalendar /> {items.StartDate}</div>
                                            <div className='text-end'>Up to Date : <BiCalendar /> {items.EndDate}</div>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className={`text-sm Pop-up  ${isCollapse[id] ? "" : "announce-data"}`}>

                                            {isCollapse[id] ? (
                                                <div className='ql-editor'>
                                                    <div dangerouslySetInnerHTML={{ __html: items.Description }} />
                                                </div>
                                            ) : (
                                                <p
                                                    style={{
                                                        lineHeight: "1.6rem",
                                                        overflow: "hidden",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 3,
                                                        WebkitBoxOrient: "vertical",
                                                        maxHeight: "4rem"
                                                    }}
                                                    className='text-sm mb-0'
                                                >
                                                    {removeTag(items.Description)}
                                                </p>
                                            )}
                                        </div>
                                    </Card.Body>

                                    <Card.Footer>
                                        <div className='d-flex align-items-center gap-2'>
                                            <Button variant='orange' className='btn-sm' onClick={() => toggleAnnouncementData(id)}>{isCollapse[id] ? <><BiChevronUp /> Show Less</> : <><BiChevronDown /> Show More</>} </Button>
                                            {items.FileStatus === "Y" && items.FileContentType !== "" &&
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
                                                    Download Attachment
                                                </Tooltip>
                                                }>
                                                    <Button variant='outline-success' className='btn-sm' onClick={() => { fetchDownloadCircular(items.TranCode, id) }}>{!downloadAtechmentLoader[id] ? <BiDownArrowAlt /> : <BiLoader className='icon-loader' />}</Button>
                                                </OverlayTrigger>
                                            }
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
                                                {items.ReadStaus === "Y" ? "Mark as unread" : "Mark as read"}
                                            </Tooltip>
                                            }>
                                                <Button variant={items.ReadStaus === "Y" ? "outline-secondary" : 'outline-blue'} className='btn-sm' onClick={() => { items.ReadStaus !== "Y" && MaskasReadCircular(items.TranCode) }}>{isCircularLoader ? <BiLoader className='icon-loader' /> : items.ReadStaus !== "Y" ? <BiEnvelope /> : <BiEnvelopeOpen />} </Button>
                                            </OverlayTrigger>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            ))}
                        </>
                        :
                        <Card className='ticket-card mt-2'>
                            <Card.Body className={` ${circularData.length === 0 && 'd-flex flex-column justify-content-center align-items-center'}`}>
                                <img src="/imgaes/svg/55024593_9264820.svg" alt="No Data Found" style={{ width: 200 }} />
                                <h1 className="text-base text-center">There are no circulars available at this time.</h1>
                            </Card.Body>
                        </Card>
                    }
                </>
                :
                <div style={{ height: '300px' }} className='d-flex justify-content-center align-items-center'>
                    <Loader />
                </div>
            }

        </div >
    )
}

export default Circular
